import * as React from 'react';
import styled from 'styled-components';
import { SvgImage } from './Image';

const BaseIcon = styled.span`
  font-family: 'Material Icons';
  font-size: 1.5rem;
`;

export const LightIcon = styled(BaseIcon)`
  color: ${props => props.theme.colors.typography.light.base};
`;

export const DarkIcon = styled(BaseIcon)`
  color: ${props => props.theme.colors.typography.dark.base};
`;

export enum SocialServiceIconType {
  Facebook = 'facebook',
  LinkedIn = 'linkedin',
  Instagram = 'instagram'
}

interface ISocialServiceIcon {
  title: string;
  src: string;
}

const StyledSocialServiceIcon = styled(SvgImage)`
  margin-right: ${props => props.theme.spacings.tiny};
`;

export const SocialServiceIcon = ({ src, title }: ISocialServiceIcon) => {
  return (
    <StyledSocialServiceIcon
      title={title}
      fixed={{
        height: 14,
        src,
        srcSet: src,
        width: 14
      }}
    />
  );
};
